export default class Select {
  constructor(className, select) {
    this._select = select;
    this._input = select.querySelector('input');
    this._trigger = select.querySelector(`${className}--trigger`);
    this._value = select.querySelector(`${className}--trigger span`);
    this._options = select.querySelectorAll(`${className}--options li`);
    this._array = [];
  }

  get select() {
    return this._select;
  }

  get trigger() {
    return this._trigger;
  }

  get options() {
    return [...this._options];
  }

  toggle(collapse) {
    if (collapse) {
      this.select.classList.add('collapsed');
    } else {
      this.select.classList.remove('collapsed');
    }
  }

  reset() {
    const item = [...this._options].filter((option) => !option.dataset || !option.dataset.value)[0];

    if (item) {
      this._value.textContent = item.textContent;
      this._input.value = '';

      [...this._options].forEach((option) => {
        if (option !== item) option.classList.remove('active');
      });

      item.classList.add('active');
    }
  }

  set value(data) {
    const multiple = this._select.classList.contains('site-select-multiple');

    if (!data.remove || !data.value) {
      if (!multiple) {
        this._value.textContent = data.text.trim();
        this._input.value = data.value.trim();
      } else {
        if (!this._input.value && data.value) {
          this._value.textContent = data.text.trim();
          this._input.value = data.value.trim();
        } else {
          this._value.textContent += `, ${data.text.trim()}`;
          this._input.value += `, ${data.value.trim()}`;
        }

        if (!data.value) {
          this._value.textContent = data.text.trim();
          this._input.value = data.value.trim();

          setTimeout(() => this.toggle(false), 400);
        }
      }
    }

    if (data.remove && data.value) {
      if (this._value.textContent.includes(`, ${data.text.trim()}`)) {
        this._value.textContent = this._value.textContent.replace(`, ${data.text.trim()}`, '');
      }

      if (this._value.textContent.includes(data.text.trim())) {
        this._value.textContent = this._value.textContent.replace(data.text.trim(), '');
      }

      if (this._input.value.includes(`, ${data.value.trim()}`)) {
        this._input.value = this._input.value.replace(`, ${data.value.trim()}`, '');
      }

      if (this._input.value.includes(data.value.trim())) {
        this._input.value = this._input.value.replace(data.value.trim(), '');
      }

      if (!this._input.value) {
        // eslint-disable-next-line prefer-destructuring
        const item = [...this._options].filter(
          (option) => !option.dataset || !option.dataset.value
        )[0];

        this._input.value = '';
        this._value.textContent = item.textContent;

        item.classList.add('active');

        setTimeout(() => this.toggle(false), 400);
      }

      if (this._input.value && this._input.value.indexOf(', ') === 0) {
        if (this._value.textContent.includes(', ')) {
          this._value.textContent = this._value.textContent.replace(', ', '');
        }

        if (this._input.value.includes(', ')) {
          this._input.value = this._input.value.replace(', ', '');
        }
      }
    }

    let item = null;
    if (data.value) {
      // eslint-disable-next-line prefer-destructuring
      item = [...this._options].filter(
        (option) => option.dataset && option.dataset.value === data.value
      )[0];
    } else {
      // eslint-disable-next-line prefer-destructuring
      item = [...this._options].filter((option) => !option.dataset || !option.dataset.value)[0];
    }

    if (!multiple || (multiple && !data.value)) {
      [...this._options].forEach((option) => {
        if (option !== item) option.classList.remove('active');
      });
    }

    if (multiple && data.value && !data.remove) {
      [...this._options].filter((option) => !option.dataset.value)[0].classList.remove('active');
    }

    if (item) {
      if (!data.remove || !data.value) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    }
  }
}
